import React from 'react';
import {t} from 'i18next';
import {IElementQuestionnaire} from '../../../../incase-domain/elements/base/questionElementBase';
import Button from '../../../../incase-domain/components/button/Button';
import {usePresentationLabels} from '../../../../hooks/usePresentationLabels';

interface ConfirmButtonProps {
    element: IElementQuestionnaire;
}

function ConfirmButton(props: ConfirmButtonProps): JSX.Element {
    const {element} = props;
    const getLabel = usePresentationLabels();

    return (
        <Button
            className="c-questionLayout__confirmButton"
            variant="solid"
            color={element.isDebatable ? 'warning' : 'info'}
            size="md"
            dynamicSize
        >
            <span>{getLabel('elements-question-try') || t('common.confirm')}</span>
        </Button>
    );
}

export default ConfirmButton;
